import React from 'react';
import moment from 'moment';
import { Card } from 'react-bootstrap';
import { Button, Col, Row } from 'react-bootstrap';

import SingleLeyendLabel from '../../../../support/SingleLeyendLabel';

const labels = [
  {
    label: 'Número de Autorización',
    index: 'noAutorizacion'
  },
  {
    label: 'Fecha de autorización',
    index: 'fechaAutorizacion',
    render: (value) => {
      return (
        <span>
          { moment(value, 'YYYY-MM-DD').format('DD/MM/YYYY') }
        </span>
      )
    }
  },
  {
    label: 'Leyenda',
    index: 'leyenda'
  }
];

const ComplementoDonatariasResumen = ({ data = {}, onEdit, onDelete }) => {
  const handleOnDelete = () => {
    onDelete('Donatarias');
  }

  const handleOnEdit = () => {
    onEdit('Donatarias', data);
  }

  const renderLeyends = (item) => {
    return (
      <SingleLeyendLabel
        key={ item.index }
        label={ item.label }
        index={ item.index }
        data={ data }
        render={ item.render }
      />
    )
  }

  return (
    <Card>
      <Card.Body>
        <Card.Subtitle className="text-center">
          Donatarias, Versión { data.version }
        </Card.Subtitle>

        <Row>
          <Col>
            { labels.map(renderLeyends) }
          </Col>
        </Row>

        <Row className="pt-3">
          <Col>
            <Button variant="danger"
              className="mr-3"
              onClick={ handleOnDelete }
            >
              Quitar
            </Button>

            <Button variant="secondary"
              onClick={ handleOnEdit }
            >
              Editar
            </Button>
          </Col>
        </Row>

      </Card.Body>
    </Card>
  )
}

export default ComplementoDonatariasResumen;
